module.exports = __webpack_public_path__ + "static/media/thermometer-half.5ff80ddd.svg";